import React, { PureComponent } from 'react';
import { Label, FormGroup, Col, Row } from 'reactstrap';
import { number, func } from 'prop-types';
import Select from '../../../../components/common/Select';
import { Input } from 'reactstrap';
import { FMessage } from '../../../../hoc/IntlComponents';

const propTypes = {
  method: number.isRequired,
  onPostbackMethodChange: func.isRequired,
};

const defaultProps = {
  method: 0,
};

const methods = [
  {
    value: 0,
    label: 'POST',
  },
  {
    value: 1,
    label: 'GET',
  },
];

class FlowPostbackMethod extends PureComponent {
  render() {
    const { method, onPostbackMethodChange } = this.props;

    return (
      <FormGroup tag="fieldset" row>
        <Label className="col-12">
          <FMessage id="postback.global.method" />
        </Label>
        <Col xs="12" className="row m-0">
          <FormGroup check className="mr-4">
            <Label check>
              <Input
                onChange={e => onPostbackMethodChange({ method: parseInt(e.target.value) })}
                checked={method === methods[0].value}
                value={methods[0].value}
                type="radio"
                name="post"
              />{' '}
              POST
            </Label>
          </FormGroup>
          <FormGroup check>
            <Label check>
              <Input
                onChange={e => onPostbackMethodChange({ method: parseInt(e.target.value) })}
                checked={method === methods[1].value}
                value={methods[1].value}
                type="radio"
                name="get"
              />{' '}
              GET
            </Label>
          </FormGroup>
        </Col>

        {/* <Select
          id="postback-method"
          name="method"
          clearable={false}
          value={method}
          onChange={({value}) => onPostbackMethodChange({method: value})}
          options={methods}
          searchable={false}
        /> */}
      </FormGroup>
    );
  }
}

FlowPostbackMethod.propTypes = propTypes;
FlowPostbackMethod.defaultProps = defaultProps;

export default FlowPostbackMethod;
